angular.module("vgresiduos").controller("SupplierViewCollectionRequestListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `fornecedor/gestao-solicitacoes`);
		};
	}
]);
